








































import Vue from 'vue';

import { init } from "./ts/main";

// import configuration options
import * as Config from "./settings/config";

// check to see if the JSON data is valid, and store the result for Vue reactivity
let isValid: boolean = false;
let errorMessage: string = "";
if (Config.init()) {
  isValid = true;
} else {
  errorMessage = "Settings are not valid, man!";
}

export default Vue.extend({
  name: 'app',

  data() {
    return {
      dataValidation: { isValid, errorMessage }
    };
  },

  mounted() {
    if (this.dataValidation.isValid) {
      init();
    } else {
      console.log(this.dataValidation.errorMessage);
    }
  }
});
